import { FIELDS_TO_TRANSFORM } from "services/sosInventoryService/reorder/schema";
import { transformFields } from "services/utility/afterGet";

export function afterGet(record) {
  return transformFields(record, FIELDS_TO_TRANSFORM);
}
